// src/hooks/useQuizViewLocal.js
import { useState, useEffect } from 'react';

export function useQuizViewLocal(qIdx, lesson, feedback) { // ✅ Añadimos feedback
  const [inputText, setInputText] = useState('');
  const [tempSelected, setTempSelected] = useState(null);
  const [matchState, setMatchState] = useState({
    selected: null,
    matched: [],
    wrong: false,
    isFinishing: false
  });

  // Se resetea cuando cambia la pregunta O cuando el feedback vuelve a ser null (Retry)
  useEffect(() => {
    if (!feedback) { // ✅ Si no hay feedback, limpiamos los estados locales
      setInputText('');
      setTempSelected(null);
      setMatchState({
        selected: null,
        matched: [],
        wrong: false,
        isFinishing: false
      });
    }
  }, [qIdx, lesson, feedback]);

  return {
    inputText,
    setInputText,
    matchState,
    tempSelected, setTempSelected,
    setMatchState
  };
}